import { useContext, useMemo, useState, useEffect } from 'react'
import { RootContext } from 'context/rootContext'
import useSignup from './hooks/useSignup'
import MODAL from 'src/utils/modals'
import { DEFAULT_VALUES } from './hooks/constants'
import { Checkbox, Input } from 'components/forms'
import Button from 'src/components/button'
import { IncompleteDataMessage } from 'components/styled'
import * as S from './styles'
import Modal from 'src/components/modal/generic'
import Alert from 'src/components/alert'

const SignupForm = ({ formData, onAccountCreated }) => {
  const [showTerms, setShowTerms] = useState(false)
  const { credentials } = useContext(RootContext)
  const isIncompleteRegister = useMemo(() => {
    return !!credentials?.authorization && !!formData
  }, [credentials, formData])
  const initialFormData = formData ? { ...formData } : DEFAULT_VALUES
  const { errors, register, submitForm, watch, setValue } = useSignup({ defaultValues: initialFormData, isIncompleteRegister, onAccountCreated })
  useEffect(() => {
    if (isIncompleteRegister) {
      handleSubmit()
    }
  }, [isIncompleteRegister])

  const handleTermsAction = (action) => {
    const ACTIONS = {
      accept: true,
      deny: false
    }
    setValue('isMktsrvTermsAccepted', ACTIONS[action])
    setShowTerms(false)
  }

  const handleSubmit = async (event) => {
    if (event) event.preventDefault()
    await submitForm({ isIncompleteRegister, onAccountCreated })
  }

  return (
    <>
      <S.FormFields onSubmit={(e) => handleSubmit(e)}>
        {
          isIncompleteRegister && (
            <IncompleteDataMessage>
              Seus dados estão incompletos. Por favor, preencha as informações que estão faltando.
            </IncompleteDataMessage>
          )
        }

        {
          errors.isMktsrvTermsAccepted?.message && (
            <Alert
              type='danger'
              show
              margin='0'
              textContent='Seus dados estão incompletos. Por favor, preencha as informações que estão faltando.'
            />
          )
        }

        <Input
          value={watch.nameClient}
          hookForm={register('nameClient', { required: true })}
          name='nameClient'
          dataTest='nameClient'
          label='Nome Completo'
          type='text'
          placeholder='Digite seu nome completo'
          errorMessage={errors.nameClient?.message}
        />
        <Input
          value={watch.documentCpf}
          hookForm={register('documentCpf', { required: true })}
          name='documentCpf'
          dataTest='documentCpf'
          label='CPF'
          type='text'
          mask='999.999.999-99'
          maskChar='_'
          placeholder='___.___.___-__'
          errorMessage={errors.documentCpf?.message}
        />
        <Input
          value={watch.birthDate}
          hookForm={register('birthDate', { required: true })}
          name='birthDate'
          dataTest='birthDate'
          label='Data de Nascimento'
          type='text'
          mask='99/99/9999'
          maskChar={null}
          placeholder='DD/MM/AAAA'
          errorMessage={errors.birthDate?.message}
          margin='8px auto 0 auto'
        />
        <Input
          value={watch.phone}
          hookForm={register('phone', { required: true })}
          name='phone'
          dataTest='phone'
          label='Telefone'
          type='text'
          mask={watch.phone && watch.phone.replace(/\D/g, '').length === 10 ? '(99) 9999-99999' : '(99) 99999-9999'}
          maskChar={watch.phone && watch.phone.replace(/\D/g, '').length === 10 ? '' : '_'}
          pattern='\(\d{2}\) \d{4}\d?-\d{4}'
          placeholder='(__) _____-____'
          errorMessage={errors.phone?.message}
          margin='8px auto 0 auto'
        />
        <Input
          value={watch.email}
          hookForm={register('email', { required: true })}
          name='email'
          dataTest='email'
          label='Email'
          type='email'
          placeholder='Digite seu email'
          isReadOnly={isIncompleteRegister && watch.email}
          errorMessage={errors.email?.message}
          margin='8px auto 0 auto'
        />
        {
          !isIncompleteRegister && (
            <>
              <Input
                eye
                value={watch.password}
                hookForm={register('password', { required: true })}
                name='password'
                dataTest='password'
                label='Senha'
                type='password'
                placeholder='Digite sua senha'
                errorMessage={errors.password?.message}
                margin='8px auto 0 auto'
              />
              <Input
                eye
                value={watch.confirmPassword}
                hookForm={register('confirmPassword', { required: true })}
                name='confirmPassword'
                dataTest='confirmPassword'
                label='Confirmar Senha'
                type='password'
                placeholder='Digite sua senha novamente'
                errorMessage={errors.confirmPassword?.message}
                margin='8px auto 0 auto'
              />
            </>
          )
        }

        <S.Container>
          <Checkbox
            checked={watch.isMktsrvTermsAccepted}
            hookForm={register('isMktsrvTermsAccepted', { required: true })}
            name='isMktsrvTermsAccepted'
            dataTest='isMktsrvTermsAccepted'
            label={<>Aceito os <a onClick={() => setShowTerms(true)}>termos de uso</a></>}
            onChangeCallback={() => setShowTerms(true)}
            errorMessage={errors.isMktsrvTermsAccepted?.message}
          />
        </S.Container>

        <Checkbox
          checked={watch.isNewsletterOptIn}
          hookForm={register('isNewsletterOptIn')}
          name='isNewsletterOptIn'
          dataTest='isNewsletterOptIn'
          label='Aceito receber promoções por email.'
          onChangeCallback={() => setValue('isNewsletterOptIn', !watch.isNewsletterOptIn)}
          type='checkbox'
        />

        <Button margin='0' theme='primary' data-test='signup-form-button-confirm' type='submit'>{isIncompleteRegister ? 'Salvar dados' : 'Criar conta'}</Button>
      </S.FormFields>
      <Modal {...MODAL.USE_TERMS({ visible: showTerms, callback: handleTermsAction })} />
    </>
  )
}

export default SignupForm
